export default __webpack_public_path__ + "static/media/xml.b0c4dda8.png";